"use strict";
'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _zeroStyled = require("../zero-styled");
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _formGroupClasses = require("./formGroupClasses");
var _useFormControl = _interopRequireDefault(require("../FormControl/useFormControl"));
var _formControlState = _interopRequireDefault(require("../FormControl/formControlState"));
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, row = ownerState.row, error = ownerState.error;
    var slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, _composeClasses.default)(slots, _formGroupClasses.getFormGroupUtilityClass, classes);
};
var FormGroupRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    variants: [
        {
            props: {
                row: true
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ var FormGroup = /*#__PURE__*/ React.forwardRef(function FormGroup(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    var className = props.className, _props_row = props.row, row = _props_row === void 0 ? false : _props_row, other = _object_without_properties(props, [
        "className",
        "row"
    ]);
    var muiFormControl = (0, _useFormControl.default)();
    var fcs = (0, _formControlState.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    var ownerState = _object_spread_props(_object_spread({}, props), {
        row: row,
        error: fcs.error
    });
    var classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormGroupRoot, _object_spread({
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
process.env.NODE_ENV !== "production" ? FormGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * Display group of elements in a compact row.
   * @default false
   */ row: _propTypes.default.bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ])
} : void 0;
var _default = exports.default = FormGroup;
